import { render, staticRenderFns } from "./ItemGroupListFilters.vue?vue&type=template&id=73fdded9"
import script from "./ItemGroupListFilters.vue?vue&type=script&lang=js"
export * from "./ItemGroupListFilters.vue?vue&type=script&lang=js"
import style0 from "./ItemGroupListFilters.vue?vue&type=style&index=0&id=73fdded9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports